import type { IconName } from '@/components/ui/Icon'

export type NavItem = {
  to: string
  labelKey: string
  icon: IconName
  openWhilePending: boolean
}

export const navItems = [
  { to: '/', labelKey: 'nav.dashboard', icon: 'grid', openWhilePending: false },
  { to: '/statistics', labelKey: 'nav.statistics', icon: 'chart', openWhilePending: false },
  { to: '/sdk', labelKey: 'nav.sdk', icon: 'code', openWhilePending: true },
  { to: '/moderation', labelKey: 'nav.moderation', icon: 'shieldCheck', openWhilePending: false },
  { to: '/plugin', labelKey: 'nav.plugin', icon: 'box', openWhilePending: false },
  { to: '/faq', labelKey: 'nav.faq', icon: 'help', openWhilePending: true },
] as const satisfies readonly NavItem[]
